import React, { useEffect } from 'react';
import TransportPageLayout from '../../components/transportation/TransportPageLayout';
import { ScheduleCard, TimesList, RatesTable } from '../../components/transportation/TransportUI';
import { setSeoMetadata } from '../../lib/seo';

const RATES = [['One Way', '$50.00'], ['Round Trip', '$65.00']];

const CarBargePage = () => {
  useEffect(() => {
    setSeoMetadata({
      title: 'Car Barge Information | St Thomas to St John | St John USVI',
      description:
        'Bring your vehicle between St Thomas and St John on the car barge. Schedules, rates and phone numbers for Love City, Global Marine and Big Red Barge.',
      keywords: 'car barge st john, st thomas to st john car barge, enighed pond car barge, red hook car barge schedule',
      canonicalPath: '/st-john-vi-car-barge-information',
      ogType: 'website',
    });
  }, []);

  return (
    <TransportPageLayout title="Car Barge Information" subtitle="St John, Virgin Islands" adId="car-barge">
      <p className="text-center text-slate-700 leading-relaxed">
        Traveling between St. Thomas and St. John is possible with your car! The car barge transports vehicles between
        St. Thomas and St. John — the driver and passengers ride along with the vehicle. Three companies currently
        offer daily service between Enighed Pond, St. John and Red Hook, St. Thomas.{' '}
        <span className="font-semibold">Times may vary due to inclement weather and barge repairs.</span>
      </p>

      <ScheduleCard
        title="Love City Car Barges"
        subtitle="Cruz Bay ↔ Red Hook · Daily"
        first
        testId="car-barge-love-city"
        operator={{ operatedBy: 'Love City', phones: ['(340) 779-4000'], location: 'Enighed Pond (Cruz Bay)', travelTime: '30 minutes' }}
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <TimesList label="Red Hook → Cruz Bay" times={['7:00 am**', '7:30 am', '9:00 am', '9:30 am*', '11:00 am', '11:30 am*', '1:00 pm', '1:30 pm*', '3:00 pm', '3:30 pm*', '5:00 pm', '5:30 pm*', '7:00 pm', '7:30 pm*']} />
          <TimesList label="Cruz Bay → Red Hook" times={['6:15 am**', '6:30 am*', '8:00 am', '8:30 am*', '10:00 am', '10:30 am*', '12:00 pm', '12:30 pm*', '2:00 pm', '2:30 pm*', '4:00 pm', '4:30 pm*', '6:15 pm', '6:30 pm*']} />
        </div>
        <p className="text-xs text-slate-500">*Except on weekends. **Except on weekends &amp; holidays.</p>
        <RatesTable rates={RATES} />
      </ScheduleCard>

      <ScheduleCard
        title="Global Marine Barge"
        subtitle="Cruz Bay ↔ Red Hook · Daily"
        testId="car-barge-global-marine"
        operator={{ operatedBy: 'Global Marine', phones: ['(340) 779-1739'], location: 'Cruz Bay', travelTime: '30-35 minutes' }}
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <TimesList label="Cruz Bay → Red Hook" times={['5:30 am', '7:15 am', '9:00 am', '11:00 am', '1:00 pm', '3:00 pm', '5:00 pm', '7:00 pm']} />
          <TimesList label="Red Hook → Cruz Bay" times={['6:00 am', '8:00 am', '10:00 am', '12:00 pm', '2:00 pm', '4:00 pm', '6:00 pm', '8:00 pm']} />
        </div>
        <p className="text-xs text-slate-500">Buying a 1-way ticket gives you more scheduling options.</p>
        <RatesTable rates={RATES} />
      </ScheduleCard>

      <ScheduleCard
        title="Big Red Barge"
        subtitle="Cruz Bay ↔ Red Hook · Daily"
        testId="car-barge-big-red"
        operator={{ operatedBy: 'Big Red Barge', phones: ['(877) 791-9125'], location: 'Cruz Bay', travelTime: '30 minutes' }}
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <TimesList label="Cruz Bay → Red Hook" times={['6:00 am', '7:30 am', '9:30 am', '11:30 am', '1:30 pm', '3:30 pm', '5:30 pm']} />
          <TimesList label="Red Hook → Cruz Bay" times={['6:30 am', '8:30 am', '10:30 am', '12:30 pm', '2:30 pm', '4:30 pm', '6:30 pm']} />
        </div>
        <p className="text-xs text-slate-500">The barge is a lifeline for local island residents.</p>
        <RatesTable rates={RATES} />
      </ScheduleCard>
    </TransportPageLayout>
  );
};

export default CarBargePage;
